module.exports = __webpack_public_path__ + "img/logo-cite-des-sciences_small.3e49acf8.png";